<template>
  <modal-wrapper :shown="formulaModalShown" @hide="hideFormulaModal">
    <div class="px-4">
      <div class="text-lg font-bold">Formula input</div>
      <input-field
        type="text"
        class="mt-6"
        autocapitalize="none"
        ref="formulaInput"
        v-model="formulaValue"
      />
      <action-button class="mt-6" @click="rollFormula"> Roll </action-button>
      <action-button class="mt-3" type="outline" @click="hideFormulaModal">
        Cancel
      </action-button>
    </div>
  </modal-wrapper>
</template>

<script>
import { call, get } from "vuex-pathify";

import ModalWrapper from "@/components/ModalWrapper";
import InputField from "@/components/inputs/InputField";
import ActionButton from "@/components/inputs/ActionButton";

export default {
  components: {
    ModalWrapper,
    InputField,
    ActionButton,
  },
  data() {
    return {
      formulaValue: "",
    };
  },
  watch: {
    formulaModalShown(formulaModalShown) {
      if (formulaModalShown === true) {
        this.$nextTick(() => {
          this.$refs.formulaInput.$el.focus();
        });
      }
    },
  },
  computed: {
    formulaModalShown: get("formulaModalShown"),
  },
  methods: {
    roll: call("roll"),
    rollFormula() {
      this.hideFormulaModal();
      this.roll({ notation: this.formulaValue, name: "Formula roll" });
      this.formulaValue = "";
    },
    hideFormulaModal: call("hideFormulaModal"),
  },
};
</script>
